/**
 * Empty cart button: one document-level click listener.
 * Works for the button in the cart drawer or on the /cart page (button may not exist on first load).
 */
(function () {
  document.addEventListener("click", function (evt) {
    if (!evt.target.closest(".js-empty-cart")) return;
    evt.preventDefault();

    var btn = evt.target.closest(".js-empty-cart");
    var container = btn ? btn.closest(".cart-items__empty-cart") : null;
    var confirmCheckbox = container ? container.querySelector(".js-empty-cart-confirm") : null;
    var inDrawer = evt.target.closest("#cart-drawer");
    var cartItemsEl = inDrawer ? document.querySelector("#cart-drawer cart-items") : document.getElementById("cart-items");

    if (!cartItemsEl || typeof cartItemsEl.refresh !== "function") return;

    var errorsEl = document.getElementById("cart-errors");
    if (errorsEl) {
      errorsEl.innerHTML = "";
      errorsEl.hidden = true;
    }

    if (confirmCheckbox && !confirmCheckbox.checked) {
      if (errorsEl) {
        errorsEl.textContent = typeof theme !== "undefined" && theme.strings && theme.strings.emptyCartConfirmRequired
          ? theme.strings.emptyCartConfirmRequired
          : "Please confirm emptying the cart first.";
        errorsEl.hidden = false;
      }
      return;
    }

    if (btn) {
      btn.classList.add("is-loading");
      btn.disabled = true;
    }

    fetch(typeof theme !== "undefined" && theme.routes && theme.routes.cart ? theme.routes.cart + "/clear.js" : "/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then(function (res) {
        if (!res.ok)
          return res.json().then(function (data) {
            throw new Error(data.message || res.status);
          });
        return cartItemsEl.refresh();
      })
      .then(function () {
        if (btn) {
          btn.classList.remove("is-loading");
          btn.disabled = false;
        }
        // Hide empty cart button(s) when cart is empty (e.g. on .cart page they stay in DOM after refresh)
        document.querySelectorAll(".cart-items__empty-cart").forEach(function (el) {
          el.style.display = "none";
        });
      })
      .catch(function (err) {
        if (errorsEl) {
          errorsEl.textContent = typeof theme !== "undefined" && theme.strings && theme.strings.cartError ? theme.strings.cartError : err.message;
          errorsEl.hidden = false;
        }
        if (btn) {
          btn.classList.remove("is-loading");
          btn.disabled = false;
        }
        console.error(err);
      });
  });
})();
